<template>
  <div>
    <div v-show="cameraStatus===status.record || cameraStatus===status.fail" class="video-wrap flex-content-between">
      <div class="camera-wrap">
        <div class="no-camera flex-row-center">
          <span v-if="num > 3" class="icon-camera"></span>
          <span v-if="num <= 3 && num >= 1" class="icon-num">{{num}}</span>
          <span class="dot" v-if="recordNum <= 3 && recordNum >= 0">00:00:0{{recordNum}}</span>
          <span class="box left-top"></span>
          <span class="box right-top"></span>
          <span class="box left-bottom"></span>
          <span class="box right-bottom"></span>
          <video width="440" height="320" class="video-frame" ref="videoDom" autoplay playsinline></video>
        </div>
      </div>
      <div class="operate-wrap">
        <h1>{{cameraStatus===status.record ? '请保持正脸对准框内':'视频录制失败'}}</h1>
        <div class="btn-wrap">
          <span :disabled="!openVideo" :class="{'fill-btn': cameraStatus===status.record, 'btn-disabled': !openVideo, 'empty-btn': cameraStatus!==status.record}" @click="startVideo(false)">
          {{cameraStatus===status.record ? '开始录制':'重新录制'}}
          </span>
          <span class="fill-btn" v-if="cameraStatus!==status.record" @click="jump">跳过</span>
        </div>
        <div class="tip-wrap">
          <p class="sub-text title">操作提示：</p>
          <p class="sub-text">
            1.请保持光源充足，不要逆光操作；<br/> 2.请保证脸部正面面向摄像头，整个脸部能够全部进入画面；<br/> 3.请录制3s视频，验证身份。<br/>4.组委会在考试结束后对本视频信息和考生信息进行核验，请考生务必严格遵守在线考试规则。
          </p>
        </div>
      </div>
    </div>
    <div v-show="cameraStatus===status.success" class="face-success">
      <h1>视频录制成功</h1>
      <p class="icon-success"></p>
      <p class="normal-text">身份验证成功，自动进入下一步～</p>
    </div>
    <div class="loading-mask" v-show="loading">
      <div>
        <loading
          :box-size="16"
          :round-size="4"
          :color="'#306FFF'">
        </loading>
      </div>
    </div>
  </div>
</template>

<script>
import RecordRTC from 'recordrtc'
import { mapState } from 'vuex'
import { qiniuUpload } from '@/utils'
import { post } from '@/utils/ajax'
import Loading from '@/components/Loading'
export default {
  components: {
    Loading
  },
  data () {
    return {
      recorderRTC: '', // rtc对象
      stream: null, // 录制的流对象
      num: 4, // 读秒
      recordNum: -1, // 录制时长
      openVideo: true, // 打开视频
      cameraStatus: 1, // 视频状态
      loading: false,
      status: {
        record: 1,
        success: 2,
        fail: 3
      }
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted() {
    this.$nextTick(() => {
      this.startVideo(true)
    })
  },
  methods: {
    async startVideo (isInit) {
      if (!isInit) {
        if (!this.openVideo) return
        this.openVideo = false
      }
      this.num = 4
      this.recordNum = -1
      this.recorderRTC = ''
      this.stream = null
      if (!navigator.mediaDevices.getUserMedia) {
        this.$emit('handleError')
        return
      }
      const contrains = {
        video: true
      }
      try {
        this.stream = await navigator.mediaDevices.getUserMedia(contrains)
        this.$refs.videoDom.muted = true
        this.$refs.videoDom.volume = 0
        this.$refs.videoDom.srcObject = this.stream
        // 录制准备
        if (!isInit) {
          this.recorderRTC = new RecordRTC(this.stream, {
            type: 'video',
            mimeType: 'video/webm'
          })
          // 加倒计时
          this.countdown()
        }
      } catch (error) {
        this.$emit('handleError')
        this.handleError()
      }
    },
    // 录制失败页面
    handleError () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.cameraStatus = this.status.fail
      this.openVideo = true
      console.log('record fail')
    },
    stopAudio () {
      // 录制时
      this.recorderRTC.stopRecording(this.stopRecordingCallback)
    },
    async stopRecordingCallback () {
      try {
        const videoBlob = this.recorderRTC.getBlob()
        const file = new File([videoBlob], 'test.webm', { type: videoBlob.type, lastModified: Date.now() })
        const videoUrl = await qiniuUpload(file, { path: `eduTest/identityCheck/${localStorage.examId}`, mimeType: [videoBlob.type] || null })
        this.submit(videoUrl)
      } catch (error) {
        console.log('record fail', error)
        this.handleError()
      }
    },
    countdown () {
      this.timer = setInterval(() => {
        this.num -= 1
        // 3秒后录制视频
        if (this.num === -1) {
          this.recorderRTC.startRecording()
          this.recorderRTC.camera = this.stream
          this.recordNum += 1
        // 录制中
        } else if (this.num <= -2 && this.num >= -4) {
          this.recordNum += 1
        // 录制结束
        } else if (this.num === -5) {
          this.recordNum += 1
          clearInterval(this.timer)
          this.timer = null
          this.stopAudio()
        }
      }, 1000)
    },
    // 自证视频提交
    async submit (videoUrl) {
      if (this.loading) return
      if (!this.user.id) {
        this.handleError()
        return
      }
      const params = {
        userId: this.user.id,
        examId: localStorage.examId,
        effectivity: videoUrl ? 1 : 0, // 1成功,0失败
        deviceId: this.$store.state.browserFinger || '',
        videoUrl: videoUrl || ''
      }
      try {
        this.loading = true
        await post('/home/face-verification/self-certification-video/submit', params)
        if (videoUrl) {
          this.cameraStatus = this.status.success
          this.recorderRTC.camera.stop()
          this.recorderRTC.destroy()
          this.recorderRTC = null
          this.stream.stop()
          this.stream = null
          setTimeout(() => {
            this.$emit('success')
          }, 1500)
        } else {
          this.$emit('success')
        }
        this.loading = false
      } catch (error) {
        console.log('record submit fail', error)
        this.loading = false
        this.handleError()
      }
    },
    jump () {
      this.recorderRTC = null
      if (this.stream) this.stream.stop()
      this.stream = null
      this.submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-wrap {
  margin-top: 48px;
}
.video-frame {
  object-fit:fill;
}
.camera-wrap {
  overflow: hidden;
  position: relative;
  background: rgba(0, 0, 0, .1);
  width: 440px;
  height: 320px;
  border-radius: 8px;
}
.no-camera {
  height: 100%;
  .dot {
    position: absolute;
    font-size: 14px;
    top: 26px;
    right: 0;
    left: 0;
    margin: auto;
    text-align: center;
    color: #fff;
    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #FF0000;
      margin-right: 10px;
      border-radius: 50%;
      vertical-align: 1px;
      animation: warn .9s infinite;
    }
  }
  @keyframes warn {
    0% {
      opacity: 1;
    }
    30% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .icon-camera {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 45px;
    height: 56px;
    background: url("~@/assets/images/identityCheck/camera.png") center / cover no-repeat;
  }
  .icon-num {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 100px;
    font-weight: 800;
    width: 60px;
    height: 140px;
    line-height: 140px;
    text-align: center;
    text-shadow: 0px 4px 10px rgba(0,0,0,0.3);
    color: #fff;
  }
  .box {
    display: inline-block;
    position: absolute;
    width: 50px;
    height: 20px;
    border: 2px solid #fff;
    opacity: .8;
  }
  .left-top {
    left: 30px;
    top: 30px;
    border-right: 0;
    border-bottom: 0;
  }
  .left-bottom {
    left: 30px;
    bottom: 30px;
    border-right: 0;
    border-top: 0;
  }
  .right-top {
    right: 30px;
    top: 30px;
    border-left: 0;
    border-bottom: 0;
  }
  .right-bottom {
    right: 30px;
    bottom: 30px;
    border-left: 0;
    border-top: 0;
  }
}
.operate-wrap {
  width: 380px;
  padding-top: 20px;
}
.tip-wrap {
  text-align: left;
  margin-top: 35px;
  .title {
    font-weight: 500;
  }
}
.btn-wrap {
  display: flex;
  justify-content: center;
  span + span {
    margin-left: 40px;
  }
}
.fill-btn {
  @include theme-fill-btn(144px, 42px, 16px, 4px);
  margin-top: 40px;
}
.empty-btn {
  @include theme-empty-btn(144px, 42px, 16px, 4px);
  margin-top: 40px;
}
.btn-disabled {
  width: 144px;
  height: 42px;
  background: #B5C6E4;
  color: #fff !important;
  border: none !important;
  border-radius: 4px;
  box-shadow: none !important;
  cursor: not-allowed;
  &:hover {
    background: #B5C6E4;
  }
}
.face-success {
  text-align: center;
  margin: 68px auto auto;
  .icon-success {
    width: 160px;
    height: 112px;
    margin: 25px auto 43px auto;
    background: url("~@/assets/images/detect/success.png") center / cover no-repeat;
  }
}
</style>
